import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'formulario-debug',
  templateUrl: './formulario-debug.component.html',
  styleUrls: ['./formulario-debug.component.css']
})
export class FormularioDebugComponent implements OnInit {

  @Input() form;

  constructor() { }

  ngOnInit() {
  }

}
